<template>
  <el-container class="container-basic">
    <!-- <el-aside :width="isCollapse ? '64px' : '230px'">
      侧边栏Aside组件
      <LayoutAside2></LayoutAside2>
    </el-aside> -->

    <el-container class="all-basic">
      <el-header>
        <!-- 控制显示和隐藏的按钮 -->
        <stu_LayoutHeader2></stu_LayoutHeader2>
      </el-header>
      <el-main class="main">
        <router-view class="router-view"></router-view>
      </el-main>
      <!-- <el-footer>Footer</el-footer> -->
    </el-container>
  </el-container>
</template>

<script>
// import LayoutAside2 from "./LayoutAside2";
import { mapGetters } from "vuex";
import stu_LayoutHeader2 from "./stu_LayoutHeader2.vue";

export default {
  components: {  stu_LayoutHeader2 },
  computed: {
    ...mapGetters(["isCollapse"]),
  },
};
</script>

<style lang="less" scoped>
.main{
  background-color:rgba(43, 52, 81, 0.454)
  ;
}
.container-basic{
  width: 100%;
  height: 100%;
  // background-image: url('../assets/11.jpg');
  background-size: cover; /* 或者 contain, 100px 100px 等 */
}


/deep/ .el-header {
  color: #333;
  height: 3% !important;
}
/deep/ .el-main{
  padding: 0;
  margin: 1%;
}
.el-aside{
  background-color: #020204c7;
  // overflow-y: hidden;
}

</style>
